export default __webpack_public_path__ + "static/media/appartment.ec05a4c2.svg";